/* eslint-disable prettier/prettier */
import i18n from "@/i18n";
import store  from '@/store'
import { MultiselectItem } from "@/models/MultiselectItem";
import {
  AvailableChannelMetadataTypes,
  AvailableChannelMetadataTypesMode,
  ChannelType,
  ChannelMetadataTypesForCampaigns,
  ChannelMetadataTypesForMediaCampaigns
} from "@/models/campaigns/ChannelType";
import { CampaignEditPageKind } from "@/models/campaigns/CampaignEditPageKind";
import { campaignCreateRoute, campaignEditRoute } from "@/router";
import { CampaignStatus } from "@/models/campaigns/CampaignStatus";
import HelperService from "./HelperService";

const namespace = "campaignsModule";

export default {
  getCampaignEditPageKind(path: string): CampaignEditPageKind {
    switch (path) {
      case campaignCreateRoute:
        return CampaignEditPageKind.Create;
      case campaignEditRoute:
        return CampaignEditPageKind.Edit;
    }
    return CampaignEditPageKind.Create;
  },

  getChannelMetadataTypes(mode: AvailableChannelMetadataTypesMode, filter?: string): MultiselectItem[] {
    const result: MultiselectItem[] = [];
    let metadataTypes: ChannelType[];
    switch (mode) {
      case AvailableChannelMetadataTypesMode.Campaigns:
        metadataTypes = ChannelMetadataTypesForCampaigns;
        break;
      case AvailableChannelMetadataTypesMode.Leads:
        metadataTypes = AvailableChannelMetadataTypes;
        break;
      case AvailableChannelMetadataTypesMode.MediaCampaigns:
        metadataTypes = ChannelMetadataTypesForMediaCampaigns;
        break;
      }
      for (const channelMetadataType of metadataTypes) {     
          const title: string = i18n.t(`Enums.ChannelMetadataType.${ChannelType[channelMetadataType]}`).toString();      
      if (!filter || title.toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
        result.push({
          Id: channelMetadataType.toString(),
          Title: title,
        });
      }
    }
    return result;
  },

  getChannelMetadataTypeIconName(type: ChannelType): string {
    switch (type) {
      case ChannelType.Crm:
        return "hand";
      case ChannelType.CrmCallCenter:
      case ChannelType.Phone:
        return "phone";
      case ChannelType.CrmImport:
        return "excel";
      case ChannelType.Direct:
        return "direct";
      case ChannelType.FacebookAdLeadCampaign:
      case ChannelType.FacebookAdLeadPage:
      case ChannelType.FacebookAds:
      case ChannelType.FacebookComments:
      case ChannelType.FacebookMessenger:
      case ChannelType.FacebookOrganic:
        return "facebook";
      case ChannelType.GoogleAdwords:
      case ChannelType.GoogleLeads:
      case ChannelType.GoogleOrganic:
        return "google-ads";
      case ChannelType.InstagramAdLeadCampaign:
      case ChannelType.InstagramAds:
      case ChannelType.InstagramComments:
      case ChannelType.InstagramMessenger:
      case ChannelType.InstagramOrganic:
        return "instagram";
      case ChannelType.LinkedinLeads:
      case ChannelType.LinkedinAds:
      case ChannelType.LinkedinOrganic:
        return "linkedin";
      case ChannelType.Newsletter:
        return "newsletter";
      case ChannelType.Outbrain:
        return "outbrain";
      case ChannelType.Print:
        return "print";
      case ChannelType.Referral:
        return "fixdigital";
      case ChannelType.Radio:
        return "radio";
      case ChannelType.TV:
        return "tv";
      case ChannelType.WhatsAppOrganic:
      case ChannelType.WhatsAppPhone:
        return "whatsapp";
      case ChannelType.Youtube:
        return "youtube";
      case ChannelType.TikTokAds:
      case ChannelType.TikTokLeads:
      case ChannelType.TikTokOrganic:
        return "tiktok"

    }
    return "";
  },

  getPageSize(): number {
    return 30;
  },

  isFacebook(channelMetadataType: ChannelType): boolean {
    return [ChannelType.FacebookAds,
      ChannelType.FacebookAdLeadCampaign,
      ChannelType.InstagramAds,
      ChannelType.InstagramAdLeadCampaign,
    ].includes(channelMetadataType);
  },

  isGoogle(channelMetadataType: ChannelType): boolean {
    return [ChannelType.GoogleAdwords, ChannelType.GoogleLeads].includes(channelMetadataType);
  },

  resetFilters(clientUser: boolean): void {
    store.dispatch(`${ namespace }/setDatePeriod`, HelperService.getThisMonthPeriod(), { root: true });
    store.dispatch(`${ namespace }/setIsMediaChannel`, false, { root: true });
    store.dispatch(`${ namespace }/setSelectedCampaignStatus`, CampaignStatus.Active, { root: true });
    store.dispatch(`${ namespace }/setSelectedChannelMetadataTypesIds`, [], { root: true });
    if (!clientUser) {
      store.dispatch(`${ namespace }/setSelectedCompaniesIds`, [], { root: true });
    }
    store.dispatch(`${ namespace }/setSelectedCampaignsIds`, [], { root: true });
    store.dispatch(`${ namespace }/setSelectedProjectsIds`, [], { root: true });
  },
};
